import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Chart, ChartConfiguration, ChartType } from 'chart.js';
import { DashboardService } from '../../pages/service/dashboard.service';
import { SalesReportOverviewComponent } from './sales-report-overview/sales-report-overview.component';
import { SalesPersonRankingComponent } from './sales-person-ranking/sales-person-ranking.component';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
import { CalendarModule } from 'primeng/calendar';
import { MovingItemsSectionComponent } from './moving-items-section/moving-items-section.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RoleAccessService } from '../../auth/role-access.service';
import { ToolbarModule } from 'primeng/toolbar';
import { InMemoryStorageService } from '../../services/in-memory-storage.service';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { UserRole } from '../../auth/roles.enum';
import { AppFeature } from '../../auth/features.enum';
import { TableModule } from 'primeng/table';
import { ProgressBar } from 'primeng/progressbar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [ButtonModule, ToolbarModule, CommonModule, CalendarModule, SalesPersonRankingComponent, CardModule, TagModule, ProgressSpinnerModule, MovingItemsSectionComponent, FormsModule, TableModule, ProgressBar, SelectButtonModule]
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('pieChart', { static: false }) pieChart!: ElementRef;

    public AppFeature = AppFeature;
    salesReportData: any[] = [];
    fastMovingItems: any[] = [];
    slowMovingItems: any[] = [];
    errorMsg: string = '';
    salesPersonRanking: any[] = [];
    customerAnalytics: any[] = [];
    topCustomers: any[] = [];
    lowMovingCustomers: any[] = [];
    loading = true;
    loadingDashboard = true;

    fromDate: string = '';
    toDate: string = '';
    todayDate: string = '';
    fromDateDashboard: string = '';
    toDateDashboard: string = '';
    chart: Chart | null = null;
    private chartColors = ['#667eea', '#f093fb', '#4facfe', '#43e97b', '#fa709a'];
    userRoles: UserRole[] = [];

    // 🟢 Added for date range toggle (Month / Year / Custom)
    dateViewOptions = [
        { label: 'This Month', value: 'month' },
        { label: 'This Year', value: 'year' },
        { label: 'Custom', value: 'custom' }
    ];
    selectedView: string = 'year';
    selectedViewDashboard: string = 'year';

    // 🟢 Added dummy structure for salesperson achievement table
    userAchievements: any[] = [];
    m3SalesAchievements: any[] = [];
    loadingM3Achievements = true;

    constructor(
        private dashboardService: DashboardService,
        private inMemoryStorageService: InMemoryStorageService,
        private roleAccessService: RoleAccessService,
        private router: Router,
        private http: HttpClient,
        private inMemoryStorage: InMemoryStorageService
    ) {}

    goToOrderHeader() {
        this.router.navigate(['/Orders1']);
    }

    ngOnInit() {
        // const today = new Date();
        // // this.todayDate = formatDate(today, 'yyyy-MM-dd', 'en');

        // // Default last month period
        // const oneMonthAgo = new Date(today);
        // oneMonthAgo.setMonth(today.getMonth() - 1);
        // this.fromDate = formatDate(oneMonthAgo, 'yyyy-MM-dd', 'en');
        // this.toDate = formatDate(today, 'yyyy-MM-dd', 'en');

        const today = new Date();
        this.toDate = formatDate(today, 'yyyy-MM-dd', 'en');

        // Get first day of the current year
        const startOfYear = new Date(today.getFullYear(), 0, 1);
        this.fromDate = formatDate(startOfYear, 'yyyy-MM-dd', 'en');

        this.userRoles = localStorage.getItem('roleGroup') ? JSON.parse(localStorage.getItem('roleGroup') || '[]') : [];
        if (this.roleAccessService.hasAccess(this.userRoles, AppFeature.Dashboard)) {
            console.warn('Access denied to Dashboard');
        }
        this.loadDashboardData();

        this.loadSalesAchievements();
        this.loadM3SalesAchievements();
    }

    loadSalesAchievements(): void {
        const company = this.inMemoryStorage.get('company');
        const division = this.inMemoryStorage.get('division');
        this.loading = true;

        const apiUrl = `${environment.apiUrl}dashboard/GetSalesReport/AllSalesPerson?company=${company}&division=${division}&fromDate=${this.fromDate}&toDate=${this.toDate}`;
        console.log(this.fromDate, this.toDate);

        this.dashboardService.loadSalesAchievementsData(this.fromDate, this.toDate).subscribe({
            next: (response: any[]) => {
                console.log(response);

                this.userAchievements = response
                    .map((item: any) => ({
                        name: item.userName || 'Unknown',
                        ordersPunched: item.ordersPunched || 0,
                        netAmount: item.netAmount || 0,
                        vatAmount: item.vatAmount || 0,
                        achievement: item.orderLineAmount || 0
                    }))
                    .sort((a, b) => b.achievement - a.achievement); // ✅ Sort descending by achievement

                console.log(this.userAchievements);
                this.loading = false;
            },
            error: (err) => {
                console.error('Error loading sales data:', err);
                this.loading = false;
            }
        });
    }

    loadM3SalesAchievements(): void {
        this.loadingM3Achievements = true;

        this.dashboardService.loadM3SalesAchievementsData(this.fromDate, this.toDate).subscribe({
            next: (response: any[]) => {
                this.m3SalesAchievements = response
                    .map((item: any) => ({
                        name: item.userName || 'Unknown',
                        ordersPunched: item.ordersPunched || 0,
                        netAmount: item.netAmount || 0,
                        vatAmount: item.vatAmount || 0,
                        achievement: item.orderLineAmount || 0
                    }))
                    .sort((a, b) => b.achievement - a.achievement);
                this.loadingM3Achievements = false;
            },
            error: (err) => {
                console.error('Error loading M3 salesperson sales data:', err);
                this.loadingM3Achievements = false;
            }
        });
    }

    ngAfterViewInit() {}

    ngOnDestroy() {
        if (this.chart) this.chart.destroy();
    }

    canAccess(feature: AppFeature): boolean {
        return this.roleAccessService.hasAccess(this.userRoles, feature);
    }

    onDateChange() {
        console.log(this.fromDate, this.toDate, 'from onDateChange');

        if (!this.isValidDateString(this.fromDate)) this.fromDate = '';
        if (!this.isValidDateString(this.toDate)) this.toDate = '';
        if (this.fromDate && this.toDate && this.toDate < this.fromDate) this.toDate = '';
        this.loadSalesAchievements();
        this.loadM3SalesAchievements();
    }

    onDateChangeDashboard() {
        if (!this.isValidDateString(this.fromDateDashboard)) this.fromDateDashboard = '';
        if (!this.isValidDateString(this.toDateDashboard)) this.toDateDashboard = '';
        if (this.fromDateDashboard && this.toDateDashboard && this.toDateDashboard < this.fromDateDashboard) this.toDateDashboard = '';
        this.loadDashboardData();
    }
    onDateViewChange() {
        const today = new Date();

        if (this.selectedView === 'month') {
            const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // last day of the current month

            this.fromDate = formatDate(startOfMonth, 'yyyy-MM-dd', 'en');
            this.toDate = formatDate(endOfMonth, 'yyyy-MM-dd', 'en');
        } else if (this.selectedView === 'year') {
            const startOfYear = new Date(today.getFullYear(), 0, 1);
            const endOfYear = new Date(today.getFullYear(), 11, 31); // 31st December

            this.fromDate = formatDate(startOfYear, 'yyyy-MM-dd', 'en');
            this.toDate = formatDate(endOfYear, 'yyyy-MM-dd', 'en');
        }

        // 'custom' -> do nothing, user selects manually
        if (this.selectedView !== 'custom') {
            this.loadSalesAchievements();
            this.loadM3SalesAchievements();
        }
    }

    onDateViewChangeDashboard() {
        const today = new Date();

        if (this.selectedViewDashboard === 'month') {
            const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // last day of month

            this.fromDateDashboard = formatDate(startOfMonth, 'yyyy-MM-dd', 'en');
            this.toDateDashboard = formatDate(endOfMonth, 'yyyy-MM-dd', 'en');
        } else if (this.selectedViewDashboard === 'year') {
            const startOfYear = new Date(today.getFullYear(), 0, 1);
            const endOfYear = new Date(today.getFullYear(), 11, 31); // 31 Dec

            this.fromDateDashboard = formatDate(startOfYear, 'yyyy-MM-dd', 'en');
            this.toDateDashboard = formatDate(endOfYear, 'yyyy-MM-dd', 'en');
        }

        if (this.selectedViewDashboard !== 'custom') {
            this.loadDashboardData();
        }
    }

    private isValidDateString(dateStr: string): boolean {
        return /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
    }

    async loadDashboardData() {
        try {
            console.log('Loading dashboard data...');
            this.loadingDashboard = true;
            let fromDate = this.fromDateDashboard;
            let toDate = this.toDateDashboard;

            if (!fromDate && !toDate) {
                const today = new Date();
                // const oneMonthAgo = new Date(today);
                // oneMonthAgo.setMonth(today.getMonth() - 1);
                // fromDate = formatDate(oneMonthAgo, 'yyyy-MM-dd', 'en');
                // toDate = formatDate(today, 'yyyy-MM-dd', 'en');
                const startOfYear = new Date(today.getFullYear(), 0, 1);
                const endOfYear = new Date(today.getFullYear(), 11, 31);

                fromDate = formatDate(startOfYear, 'yyyy-MM-dd', 'en');
                toDate = formatDate(endOfYear, 'yyyy-MM-dd', 'en');
                this.fromDateDashboard = fromDate;
                this.toDateDashboard = toDate;
            }

            const safe = (promise: Promise<any>, fallback: any = []) => promise.catch(() => fallback);

            const [fastMovingItems, slowMovingItems, topCustomers, lowMovingCustomers] = await Promise.all([
                safe(firstValueFrom(this.dashboardService.getTopFiveItemsSold(fromDate, toDate))),
                safe(firstValueFrom(this.dashboardService.getLeastFiveItemsSold(fromDate, toDate))),
                safe(firstValueFrom(this.dashboardService.getTopFiveCustomersBySales(fromDate, toDate))),
                safe(firstValueFrom(this.dashboardService.getLeastFiveCustomersBySales(fromDate, toDate)))
            ]);

            this.fastMovingItems = fastMovingItems || [];
            this.slowMovingItems = (slowMovingItems as any[]) || [];
            this.topCustomers = topCustomers || [];
            this.lowMovingCustomers = lowMovingCustomers || [];

            setTimeout(() => this.updateChart(), 0);
        } catch (error) {
            this.errorMsg = 'Failed to load dashboard data.';
            console.error('Error loading dashboard data:', error);
        } finally {
            this.loadingDashboard = false;
        }
    }

    // 🟢 Helper to compute percentage progress
    getProgress(person: any): number {
        if (!person.target) return 0;
        return Math.min(100, Math.round((person.achievement / person.target) * 100));
    }

    // 🟢 Status text logic
    getStatusText(progress: number): string {
        if (progress >= 100) return 'Exceeded';
        if (progress >= 80) return 'On Track';
        if (progress >= 50) return 'Needs Improvement';
        return 'Behind';
    }

    // 🟢 Tag color based on performance
    getProgressColor(progress: number): string {
        if (progress >= 100) return 'success';
        if (progress >= 80) return 'info';
        if (progress >= 50) return 'warning';
        return 'danger';
    }

    getChartColor(index: number): string {
        return this.chartColors[index] || '#6c757d';
    }

    updateChart() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }

        if (this.pieChart && this.topCustomers.length > 0) {
            const ctx = this.pieChart.nativeElement.getContext('2d');
            const config: ChartConfiguration = {
                type: 'pie' as ChartType,
                data: {
                    labels: this.topCustomers.map((customer) => customer.customerName),
                    datasets: [
                        {
                            data: this.topCustomers.map((customer) => customer.totalAmount),
                            backgroundColor: this.chartColors.slice(0, this.topCustomers.length),
                            borderColor: ['#5a67d8', '#ed64a6', '#4299e1', '#38a169', '#e53e3e'].slice(0, this.topCustomers.length),
                            borderWidth: 2,
                            hoverOffset: 4
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'bottom',
                            labels: {
                                padding: 20,
                                usePointStyle: true,
                                font: { size: 12 }
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    const label = context.label || '';
                                    const value = context.parsed;
                                    const total = (context.dataset.data as number[]).reduce((a, b) => a + b, 0);
                                    const percentage = ((value / total) * 100).toFixed(1);
                                    return `${label}: €${value.toLocaleString()} (${percentage}%)`;
                                }
                            }
                        }
                    }
                }
            };

            this.chart = new Chart(ctx, config);
        }
    }
}
